// Pure helpers behind <NumberInput>. Kept DOM-free so they're unit-testable.

/**
 * Parse what the user typed into a model value.
 * - `null`  → the field is empty (or a partial `-` / `.`), i.e. "no value yet"
 * - `undefined` → un-parseable transient garbage; caller should keep the prior value
 * - a number → the committed value (truncated when `integer`)
 */
export function parseNumberField(raw: string, integer: boolean): number | null | undefined {
  const trimmed = raw.trim();
  if (trimmed === '' || trimmed === '-' || trimmed === '.' || trimmed === '-.') return null;
  const n = Number(trimmed);
  if (!Number.isFinite(n)) return undefined;
  return integer ? Math.trunc(n) : n;
}

/** Normalise a committed value on blur: truncate to int, then clamp to [min,max]. */
export function clampNumberField(
  value: number,
  opts: { integer?: boolean; min?: number; max?: number },
): number {
  let v = value;
  if (opts.integer) v = Math.trunc(v);
  if (opts.min != null && v < opts.min) v = opts.min;
  if (opts.max != null && v > opts.max) v = opts.max;
  return v;
}
